export default class BContentToggle
{
	static initialize()
	{
		document.addEventListener("click", event => {
			const trigger = event.target.closest(".sh-trig[data-content]");
			if (trigger) {
				event.preventDefault();

				const content = document.getElementById(trigger.dataset.content);
				if (!content) {
					return;
				}

				const allTriggers = document.querySelectorAll(`.sh-trig[data-content="${trigger.dataset.content}"]`);

				if (content.classList.contains("sh-visible")) {
					content.classList.remove("sh-visible");
					allTriggers.forEach(t => t.classList.remove("active"));
				} else {
					content.classList.add("sh-visible");
					allTriggers.forEach(t => t.classList.add("active"));
				}

				return;
			}

			if (event.target.closest(".btn-filter")) {
				const rcpTrigger = document.querySelector(".rcp-filter-trig");
				if (rcpTrigger) {
					rcpTrigger.click();
				}
			}
		});
	}
}
